<template>
    <div class="container">
        <content-header title="Психосоматические расстройства, как реакция на психосоциальный стресс"/>
        <article-detail-component :data="detail"/>
<!--        <comment-form id="comment-form" slug="" class="comment-wrapper"/>-->
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import CommentForm from "@/components/CommentForm";
import ArticleDetailComponent from "@/components/ArticleDetailComponent";

export default {
    name: "",
    components: {
        ContentHeader,
        CommentForm,
        ArticleDetailComponent
    },
    data() {
        return {
            detail: {
                created: '12 АПР 17',
                title: 'Психосоматические расстройства, как реакция на психосоциальный стресс',
                description: `

<p style="padding: 1em 0; color: #666;">По прогнозам Всемирной организации здравоохранения, в ближайшие десятилетия именно психические расстройства войдут в число наиболее распространенных болезней.</p>
<p style="padding: 1em 0; color: #666;">Конфликты, стрессы, волнения вызывают перенапряжение функции жизненно важных органов и систем человека, возникает&nbsp; психоэмоциональная напряженность, которая ведет к <strong>психосоматическим расстройствам. </strong></p>
<p style="padding: 1em 0; color: #666;">Психосоматические расстройства (ПСР) — функциональные нарушения внутренних органов и систем, возникновение и развитие которых связано с переживанием острой или хронической психологической травмы, специфическими особенностями эмоционального реагирования личности.</p>
<p style="padding: 1em 0; color: #666;"><strong>Психосоматические расстройства</strong> могут вызывать <strong>головные «боли напряжения»</strong> – ощущение надетой на голову и тягостно сдавливающей ее тесной «каски»; нарушение глотания и ощущение «комка» в горле; спазм мышц, управляющих голосовыми связками — нарушение голосообразования («перехватило голос»). Человек нередко теряет голос в минуты сильного психотравмирующего воздействия.</p>
<p style="padding: 1em 0; color: #666;">Часто наблюдается <strong>одышка</strong>, не связанная с болезнями органов дыхания: чувство «неудовлетворенности» вдохом – желание вздохнуть поглубже (последнее может приводить к избыточно глубокому дыханию – гипервентиляционный синдром); <strong>лабильность пульса и артериального давления;</strong> неприятные ощущения в области сердца в виде <strong>загрудинной тяжести,</strong> болевых ощущений (подобные функциональные кардиалгии, психогенного характера описываются выражением «принимать близко к сердцу»); <strong>аритмия</strong> и чувства «провалов в груди», «замирания сердца», заставляющие человека болезненно, с тревожным ожиданием вслушиваться в свой сердечный ритм.</p>
<p style="padding: 1em 0; color: #666;">Отмечаются &nbsp;<strong>функциональные желудочно-кишечные нарушения (</strong>психогенная тошнота, рвота, расстройство стула и повторяющиеся эпизоды болей в животе, в том числе и при синдроме раздраженного кишечника (СРК) – как результат глубоко запрятанных психологических проблем) <strong>и мочеполовые нарушения</strong>.</p>
<p style="padding: 1em 0; color: #666;">Все вышеперечисленное может сопровождаться <strong>приливами жара</strong> («кровь бросилась в голову») или <strong>озноба </strong>(«от страха все внутри заледенело»), иногда волнообразно сменяющих друг друга («бросает то в жар, то в холод»), мышечным тремором («волнуюсь буквально до дрожи в руках и ногах») с болезненными судорогами икроножных мышц, а также нарушением сна — бессонница или, наоборот, сонливость, сопровождающаяся ощущением того, что сна было недостаточно (иными словами, человек после пробуждения чувствует себя «разбитым», иногда может даже жаловаться на боли в мышцах).</p>
<p style="padding: 1em 0; color: #666;">Самые частые проявления психосоматических расстройств, связанных со стрессовыми расстройствами &nbsp;на психологическом уровне: беспокойство, тревога в чистом виде, сниженное настроение, эмоциональная лабильность, немотивированная раздражительность и конфликтность, стремление отгородиться от реальной жизни, как источника стресса, изолироваться от повседневной суеты, напоминающей о стрессовых событиях.</p>
<p style="padding: 1em 0; color: #666;"><strong>Приглашаем Вас на консультацию к высококвалифицированным психотерапевтам ФГБУ «Поликлиника №5». Наши специалисты окажут Вам психологическую помощь и помогут своевременно предотвратить психосоматические проявления и развитие тревожно-депрессивных расстройств.&nbsp;</strong></p>
<p style="padding: 1em 0; color: #666;">&nbsp;</p>
<p style="padding: 1em 0; color: #666;">Ведут прием:</p>
<p style="padding: 1em 0; color: #666;">&nbsp;</p>
<p style="padding: 1em 0; color: #666;"><strong>Уваров Владимир Викторович,</strong></p>
<p style="padding: 1em 0; color: #666;"><strong><em>Врач-психотерапевт, к.м.н.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em></strong></p>
<p style="padding: 1em 0; color: #666;">&nbsp;</p>
<p style="padding: 1em 0; color: #666;"><strong>Плюхина Юлия Александровна &nbsp;</strong></p>
<p style="padding: 1em 0; color: #666;"><strong>Врач-психотерапевт &nbsp; &nbsp; &nbsp;</strong></p>
<p style="padding: 1em 0; color: #666;">&nbsp;</p>
<p style="padding: 1em 0; color: #666;"><strong><a style="color: #006688; border-bottom: 1px dotted #006688;" href="http://5-clinic.com/contact/"><em>Записаться на прием</em></a> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</strong></p>
<p style="padding: 1em 0; color: #666;"><strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</strong></p>

            `
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

</style>

<style lang="scss" scoped>
.article-detail {
    display: flex;
    margin-top: 30px;

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .comments_number {
            width: 100%;
            margin-top: 4px;
            background-color: #00b6cc;
            padding: 10px 12px;
            color: #fff;
            font-size: 12px;
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;
    }

    &__title {
        text-align: left;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        width: 60%;

        img {
            width: 100%;
            margin: 5px 20px 20px 0;
        }
    }

    &__desc {

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }
    }
}

.comment-wrapper {
    margin-left: 120px;
    margin-top: 30px;
    padding: 10px;

    @media screen and (max-width: 570px) {
        margin-left: 0;
    }
}
</style>

<style>
.article-detail__content {
    width: 100% !important;
}
</style>
